import * as colorsExport from "./colors"

export const colors = colorsExport
